import population from './populationMap';
import customConnect from '../customConnect';
import {getActive, getColorMap} from './reducer';
import {map} from '../map/map';
import {setPopup} from '../popup/actions';


const propNameMap = {
	"iedz0-1": "0 - 1 gadi",
	"iedz2-4": "2 - 4 gadi",
	"iedz5-6": "5 - 6 gadi",
	"iedz7-12": "7 - 12 gadi",
	"iedz13-15": "13 - 15 gadi",
	"iedz16-18": "16 - 18 gadi",
	"iedz19-25": "19 - 25 gadi",
	"iedz26-30": "26 - 30 gadi",
	"iedz31-62": "31 - 62 gadi",
	"iedz0_6": "0 - 6 gadi",
	"iedz7_18": "7 - 18 gadi",
	"iedz19_62": "19 - 62 gadi",
	"iedz63": "63 gadi"
}

const generateEntryProps = (data, group) => {

	// data;
	var totalGroup = 0;
	var total = 0;
	if(typeof data.features !== 'undefined') {

		for (var i = data.features.length - 1; i >= 0; i--) {

			totalGroup += data.features[i].getProperties()[group];
			total += data.features[i].getProperties()['total'];
		}
	}

	return [
		{value: propNameMap[group] + ': ' + totalGroup + ', kopā: ' + total}
	];

	return [
		{name: 'Adrese', value: props['Adrese']},
		{name: '0 - 6 gadi', value: props['iedz0_6']},
		{name: '7 - 18 gadi', value: props['iedz7_18']},
    	{name: '18 - 62 gadi', value: props['iedz19_62']},
	/*	{name: '0 - 1 gadi', value: props['iedz0-1']},
		{name: '2 - 4 gadi', value: props['iedz2-4']},
    	{name: '5 - 6 gadi', value: props['iedz5-6']},
    	{name: '7 - 12 gadi', value: props['iedz7-12']},
		{name: '13 - 15 gadi', value: props['iedz13-15']},
		{name: '16 - 18 gadi', value: props['iedz16-18']},
		{name: '19 - 25 gadi', value: props['iedz19-25']},
		{name: '26 - 30 gadi', value: props['iedz26-30']},
		{name: '31 - 62 gadi', value: props['iedz31-62']},*/
		{name: '63 gadi', value: props['iedz63']}
    ];
}

export default function (store) { //new props and action function

	var colorMap = getColorMap(store.getState());
	var ind = new population({map, colorMap});
	
	const mapStateToPropsRes = (state) => {

		return {
			activeIndustries: getActive(state),
			colorMap: getColorMap(state),
			radiusMod: state.pointSizeSlider.percent / 4 / 100
		}
	}

	const mapDispatchToPropsRes = (dispatch) => {

	  return {
	    selectFeature: (data, group, zoomLvl) => {
	    
	    	if(data.length === 1) {

	    		var props = data[0].getProperties();
	    		
	    		dispatch(setPopup(generateEntryProps(props, group)));
	    		return;
	    		
	    	} else if( data.length > 1) {

	    		var subData = [];

	    		data.sort((a, b) => {

	    			return a.getProperties()[VALUE_FIELD] - b.getProperties()[VALUE_FIELD];
	    		});

	    		for (var i = data.length - 1; i >= 0; i--) {
	    			var props = data[i].getProperties();
		    		subData.push(generateEntryProps(props));
	    		}

	    		//if(zoomLvl...)

	    		dispatch(setPopup([
	    		//	{text: 'Nozare', value: props['Nozare']},
	    			{name: 'Nozare', value: group},
	    			{name: 'Pievienotā vērtība', value: countProp(data, VALUE_FIELD) + ' tūkst. EUR '},
	    			{childs: subData}
	    		]));
	    		
	    	} else {

	    		dispatch(setPopup([]));
	    	}

	    	
	    }
	  }
	}

	customConnect(mapStateToPropsRes, mapDispatchToPropsRes, store, ind.stateUpdateHandler);
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/population/mapContainer.js